export const REGISTER_COMPONENT = "registerComponent";
export const EXTRA_DOM_LOADED_EVENT = "extraDomLoadedEvent";